import classNames from 'classnames/bind'

import Styles from './InsuranceDetailGuideList.module.scss'

const cx = classNames.bind(Styles)

const InsuranceDetailGuideList = () => {
    return (
        <ul className={cx('article')}>
            <li className={cx('item')}>
                해당 보험은{' '}
                <em className={cx('point-color')}>
                    주민등록상 주소를 두고 있는 지자체에서 무료로 가입해 주는 보험입니다. 별도 가입 절차 없이 자동 가입
                </em>
                됩니다.
            </li>
        </ul>
    )
}

export default InsuranceDetailGuideList
